


<template>
  <div>

    <b-card class="p-1 my-1">
      <b-row>
        <AppBreadcrumb class="col-9"/>

        <b-col class="d-flex justify-content-end"></b-col>
      </b-row>

      <hr>
      
      <FormFilterInterconsultas />

    </b-card>

    <TableInterconsultas/>

    <InterconsultaModalCompletar/>
    <InterconsultaModalView/>
    <ModalItemsByAtencion/>
  </div>
</template>

<script>
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'; 
import actions from '@/assets/utils/utils';
import { BootstrapVue } from 'bootstrap-vue';
import { 
  FormFilterInterconsultas, 
  InterconsultaModalCompletar,
  InterconsultaModalView,
  TableInterconsultas,
  ModalItemsByAtencion
} from '../components';

export default {
  name: "InterconsultasPage",

  components: {
    ...BootstrapVue.components,
    AppBreadcrumb,
    FormFilterInterconsultas,
    InterconsultaModalCompletar,
    InterconsultaModalView,
    TableInterconsultas,
    ModalItemsByAtencion
  },


  data(){
    return{
      
    }
  },

  mounted() {
    actions.setearTitulo('Interconsultas')
  },

  methods:{

    onShowModalCreate(){
      this.$store.commit("setModalCrearInterconsultas", { isVisible: true });
    }
  }

}
</script>